module.exports = __webpack_public_path__ + "static/media/ser_gas_com_not.480ed710.png";